// SPDX-FileCopyrightText: © 2023 Schneider Electric
//
// SPDX-License-Identifier: Apache-2.0

import { Component, Element, h, Host, State } from "@stencil/core";

import { onMobileBreakpoint } from "../utils";

/**
 * @slot title - Title content for the megamenu list group.
 */
@Component({
  tag: "qds-web-megamenu-list-group",
  styleUrl: "megamenu-list-group.css",
  shadow: true,
})
export class MegamenuListGroup {
  @Element() public el: HTMLElement;

  @State() public isMobile: boolean;

  private cleanupMobileListener?: () => void;

  public componentWillLoad(): Promise<void> | void {
    this.cleanupMobileListener = onMobileBreakpoint((isMobile: boolean) => {
      this.isMobile = isMobile;
    }, this.el);
  }

  public disconnectedCallback(): void {
    this.cleanupMobileListener?.();
  }

  public render() {
    return (
      <Host>
        <slot name="title" />
        <div
          class={{
            web: !this.isMobile,
          }}
          role="list"
        >
          <slot />
        </div>
      </Host>
    );
  }
}
